import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import WithdrawalSeuContainer from 'pages/Withdrawal/SEU/WithdrawalSeu.container';
import { WithdrawalMode } from 'services/withdrawal/withdrawal.config';
import { z } from 'zod';

const withdrawalSearchSchema = z.object({
  formIdFromUrl: z.string().optional(),
  amount: z.number().optional(),
  method: z.enum(WithdrawalMode).optional(),
});

export const Route = createFileRoute('/_auth/withdrawal/')({
  component: WithdrawalSeuContainer,
  validateSearch: zodValidator(withdrawalSearchSchema),
});
